export const PUBLIC_MOORAGE_GREEN = '#61B346';
export const PUBLIC_MOORAGE_DARK_GREEN = '#2D7223';
export const PRIVATE_LISTING_BLUE = '#4472C4';
export const PRIVATE_LISTING_DARK_BLUE = '#000064';
export const OCCUPIED_DOT_GREY = '#BFBFBF';
export const GROUPED_LISTING_BADGE_RED = '#FF3B30';

export const CHECK_IN_STATE_CHECKED_IN = 'Checked In';
export const CHECK_IN_STATE_RELEASED = 'Released';

export const ACCESS_FILTER_QUERY_PARAM = 'access';
export const ACCESS_FILTER_ALL = 'all';
export const ACCESS_FILTER_PUBLIC = 'public';
export const ACCESS_FILTER_PRIVATE = 'private';

export const CHECK_IN_GEOFENCE_RADIUS_METERS = 1000;
